import { ALLOWED_ATTACHMENT_SIZE } from 'consts/consts';
import { LS } from 'consts/localStorage';
import { getFileTypeImg, readFromLs } from 'helpers/helpers';
import { getAttachmentTransactionId } from 'helpers/socket';
import { ENGT_CHAT } from 'js/bot.model';
import { AttachmentsTemplate } from './attachments.template';

export class FileAttachments {
	constructor(props) {
		if (ENGT_CHAT.get('config.enableUploadAttachment')) {
			this.initData();
			this.initWrapper();
			this.initComponents();
			this.initEvents();
			this.initHelpers();
		} else {
			this.html = document.createDocumentFragment();
		}
	}

	initData() {
		this.data = {};
		this.setter({
			placeholder: ENGT_CHAT.get('config.textAreaPlaceholder'),
		});
	}

	initWrapper() {
		const wrapper = document.createElement('div');
		wrapper.innerHTML = AttachmentsTemplate();

		this.html = wrapper;
	}

	initComponents() {
		this.fileUploadBtn = this.html.querySelector('#engtAttachmentInput');

		if (readFromLs(LS().LIVECHAT) === 'true') {
			this.showUploadBtn();
		} else {
			this.hideUploadBtn();
		}
	}

	initEvents() {
		const ref = this;

		function onFileSelection(e) {
			const [file] = e.target.files;
			const [, fileType] = file?.type?.split?.('/');

			if (file) {
				if (file.size > ALLOWED_ATTACHMENT_SIZE) {
					alert('Maximum allowed file size - 25mb');
				} else {
					const img = document.querySelector('#attachmentPreviewImg');
					if (file.type.indexOf('image') > -1) {
						img.src = URL.createObjectURL(file);
						img.style = '';
						img.parentNode.style.justifyContent = 'center';
						document.querySelector('#attachmentPreviewFileName').innerText = '';
					} else {
						img.src = getFileTypeImg(fileType);
						img.style = 'height: 100px; margin: unset;';
						img.parentNode.style.justifyContent = null;
						document.querySelector('#attachmentPreviewFileName').innerText = file.name;
					}
					ref.openModal();
				}
			} else {
				alert('Invalid file type');
			}
		}

		this.fileUploadBtn.addEventListener('change', onFileSelection);
		this.fileUploadBtn.addEventListener('click', () => {
			if (!ENGT_CHAT.get('attachmentTransactionId')) {
				getAttachmentTransactionId();
			}
		});
	}

	initHelpers() {
		ENGT_CHAT.set('showUploadBtnForLiveChat', this.showUploadBtn.bind(this));
		ENGT_CHAT.set('hideUploadBtnForLiveChat', this.hideUploadBtn.bind(this));
	}

	showUploadBtn() {
		this.html.style.display = 'block';
	}

	hideUploadBtn() {
		this.html.style.display = 'none';
	}

	openModal() {
		document.getElementById('engtChatFooter').style.transform = 'unset';
		ENGT_CHAT.get('openAttachmentsModal')();
	}

	setter(propData) {
		this.data = {
			...this.data,
			...propData,
		};
	}

	render() {
		return this.html;
	}
}
